import { render } from "./docterPage.vue?vue&type=template&id=32663dec"
import script from "./docterPage.vue?vue&type=script&lang=js"
export * from "./docterPage.vue?vue&type=script&lang=js"

import "./docterPage.vue?vue&type=style&index=0&id=32663dec&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__